export default __webpack_public_path__ + "static/media/precincts2017.a881e40b.txt";